<div class="preview-banner">
  <span class="banner-label">
    <mat-icon class="material-symbols-outlined">visibility</mat-icon>
    Pré-visualização — é assim que o fornecedor verá a cotação. Itens de exemplo.
  </span>
  <button mat-icon-button type="button" class="preview-close" (click)="fechar()" matTooltip="Fechar">
    <mat-icon>close</mat-icon>
  </button>
</div>

<div class="portal-page">
  <div class="portal-doc">

    <header class="portal-hero" [style.background]="heroGradient">
      <div class="hero-brand">
        @if (data.urlLogo) {
          <span class="hero-logo"><img [src]="data.urlLogo" alt="Logo"></span>
        } @else {
          <span class="hero-logo-fallback" [style.background]="data.corMarca">{{ data.marcaSigla }}</span>
        }
        <div class="hero-brand-text">
          <strong>{{ data.razaoSocial || 'Sua empresa' }}</strong>
          <span>{{ data.marcaRodape }}</span>
        </div>
      </div>
      <div class="hero-meta">
        <div class="hero-doc-type">Solicitação de cotação</div>
        <div class="hero-doc-number">COT-2026-0042</div>
        <div class="hero-chips">
          <span class="hero-chip">
            <mat-icon class="material-symbols-outlined">event</mat-icon>
            Emitida em 02/07/2026
          </span>
          <span class="hero-chip">
            <mat-icon class="material-symbols-outlined">timer</mat-icon>
            Responder até 09/07/2026
          </span>
        </div>
      </div>
    </header>

    <div class="portal-body">

      @if (data.mensagem) {
        <section class="portal-section">
          <p class="portal-mensagem">{{ data.mensagem }}</p>
        </section>
      }

      <section class="portal-section">
        <h3 class="portal-section-title"><i [style.background]="data.corMarca"></i>Dados do comprador</h3>
        <div class="info-grid">
          <div class="info-item">
            <small>Razão social</small>
            <span>{{ data.razaoSocial || '—' }}</span>
          </div>
          <div class="info-item">
            <small>CNPJ</small>
            <span>{{ data.cnpj || '—' }}</span>
          </div>
          <div class="info-item info-wide">
            <small>Endereço</small>
            <span>{{ data.endereco || '—' }}</span>
          </div>
        </div>
      </section>

      <section class="portal-section">
        <h3 class="portal-section-title"><i [style.background]="data.corMarca"></i>Itens solicitados</h3>
        <div class="items-scroll">
          <table class="items-table">
            <thead>
              <tr>
                <th>Produto</th>
                <th class="num">Qtd</th>
                <th>Un</th>
                @if (isAtivo('campoPrecoUnitario')) { <th class="num">Preço unitário</th> }
                @if (isAtivo('campoIpi')) { <th class="num">IPI</th> }
                @if (isAtivo('campoSt')) { <th class="num">ST</th> }
                @if (isAtivo('campoDisponibilidade')) { <th>Disponível?</th> }
              </tr>
            </thead>
            <tbody>
              @for (item of itens; track item.sku) {
                <tr>
                  <td class="item-nome">
                    <strong>{{ item.nome }}</strong>
                    <small>SKU {{ item.sku }}</small>
                  </td>
                  <td class="num">{{ item.quantidade }}</td>
                  <td>{{ item.unidade }}</td>
                  @if (isAtivo('campoPrecoUnitario')) {
                    <td class="num"><input class="proposta-input proposta-input--valor" placeholder="R$ 0,00"></td>
                  }
                  @if (isAtivo('campoIpi')) {
                    <td class="num"><input class="proposta-input proposta-input--valor" placeholder="R$ 0,00"></td>
                  }
                  @if (isAtivo('campoSt')) {
                    <td class="num"><input class="proposta-input proposta-input--valor" placeholder="R$ 0,00"></td>
                  }
                  @if (isAtivo('campoDisponibilidade')) {
                    <td>
                      <select class="proposta-input proposta-input--select">
                        <option>Sim</option>
                        <option>Parcial</option>
                        <option>Não</option>
                      </select>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      </section>

      <section class="portal-section">
        <h3 class="portal-section-title"><i [style.background]="data.corMarca"></i>Condições da proposta</h3>
        <div class="proposta-grid">
          <div class="proposta-field">
            <label>Data de entrega desejada</label>
            <span class="proposta-fixed">15/07/2026 <em>(definida pelo comprador)</em></span>
          </div>
          @if (isAtivo('campoPrazoEntrega')) {
            <div class="proposta-field">
              <label>Prazo de entrega (dias)</label>
              <input class="proposta-input" placeholder="Ex.: 10">
            </div>
          }
          @if (isAtivo('campoFrete')) {
            <div class="proposta-field">
              <label>Frete</label>
              <div class="proposta-inline">
                <select class="proposta-input proposta-input--select">
                  <option>CIF</option>
                  <option>FOB</option>
                </select>
                <input class="proposta-input" placeholder="R$ 0,00">
              </div>
            </div>
          }
          @if (isAtivo('campoCondicaoPagamento')) {
            <div class="proposta-field">
              <label>Condição de pagamento ofertada</label>
              <input class="proposta-input" placeholder="Ex.: 28/56 dias">
            </div>
          }
          @if (isAtivo('campoValidadeProposta')) {
            <div class="proposta-field">
              <label>Validade da proposta</label>
              <input class="proposta-input" type="date">
            </div>
          }
          <div class="proposta-field proposta-field--wide">
            <label>Observações</label>
            <textarea class="proposta-input" rows="3" placeholder="Informações adicionais sobre a proposta"></textarea>
          </div>
        </div>
      </section>

      <section class="portal-section portal-submit">
        <button type="button" class="btn-enviar" [style.background]="data.corMarca"
          matTooltip="Demonstração — o envio real acontece no portal do fornecedor">
          <mat-icon class="material-symbols-outlined">send</mat-icon>
          Enviar proposta
        </button>
        <p class="submit-hint">Ao enviar, sua proposta fica registrada e a equipe de compras é notificada.</p>
      </section>
    </div>

    <footer class="portal-footer">
      <strong>{{ data.razaoSocial || 'Sua empresa' }}</strong> · {{ data.emailContato }} · {{ data.telefoneContato }}
      <br>{{ data.urlSite }}
    </footer>
  </div>
</div>
